import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type BalanceSliceState = {
  balance: {
    currencySymbol: string;
    amount: number;
    userCurrency: string;
  };
  exposure: {
    currencySymbol: string;
    amount: number;
    userCurrency: string;
  };
};

/*
 * Empty, not USD. Seeding a real currency made "not arrived yet" look
 * like "this player is on dollars", so screens swapped USD for rupees
 * and every genuine USD player got the wrong mark.
 */
const initialState: BalanceSliceState = {
  balance: {
    currencySymbol: '',
    amount: 0,
    userCurrency: '',
  },
  exposure: {
    currencySymbol: '',
    amount: 0,
    userCurrency: '',
  },
};

export const BALANCE_SLICE_KEY = 'balance';

const balanceSlice = createSlice({
  name: BALANCE_SLICE_KEY,
  initialState,
  reducers: {
    setBalance: (
      state,
      action: PayloadAction<{
        currencySymbol: string;
        amount: number;
        userCurrency: string;
      }>
    ) => {
      state.balance = action.payload;
    },
    setExposure: (
      state,
      action: PayloadAction<{
        currencySymbol: string;
        amount: number;
        userCurrency: string;
      }>
    ) => {
      state.exposure = action.payload;
    },
  },
});

export const balanceActions = balanceSlice.actions;
export const balanceSelector = (state: {
  [BALANCE_SLICE_KEY]: BalanceSliceState;
}) => state[BALANCE_SLICE_KEY];
export default balanceSlice.reducer;
